"use client"
import React from "react";
import Link from "next/link";
import "./breadcrumb.scss";

const Breadcrumb = ({ handles }) => {
  // If handles is just a simple string (product name), show only Home
  if (typeof handles === "string" && handles && !handles.includes("/")) {
    return (
      <div className="breadcrumb-container">
        <Link href="/fashion" className="breadcrumb-link">
          Home
        </Link>
        <span>{" / "}</span>
        <span className="breadcrumb-current">
          {handles.replace(/-/g, " ")}
        </span>
      </div>
    );
  }

  // Convert handles to array if it's a path string
  let handleArray = [];
  
  if (typeof handles === "string" && handles) {
    handleArray = handles.split("/").filter(h => h && h.trim() !== "");
    // Remove the last item (product name) to show only categories
    handleArray = handleArray.slice(0, -1);
  } else if (Array.isArray(handles)) {
    handleArray = handles.filter(h => h && h.trim() !== "");
    // Remove the last item (product name) to show only categories
    handleArray = handleArray.slice(0, -1);
  }

  return (
    <div className="breadcrumb-container">
      <Link href="/fashion" className="breadcrumb-link">
        Home
      </Link>
      {handleArray && handleArray.length > 0
        ? handleArray.map((handle, index) => {
            const href = `/fashion/${handleArray.slice(0, index + 1).join("/")}`;
            return (
              <span key={`${handle}-${index}`}>
                {" / "}
                <Link href={href} className="breadcrumb-link">
                  {handle.replace(/-/g, " ")}
                </Link>
              </span>
            );
          })
        : ""}
    </div>
  );
};

export default Breadcrumb;
